export const services = [
  {
    id: 'custom-software',
    title: 'Custom Software',
    tagline: 'Built for your exact workflow',
    blurb:
      'Tailored applications engineered around your business logic — from internal tooling to customer-facing platforms.',
    details: [
      'Domain-driven architecture',
      'Microservices & APIs',
      'Legacy system modernization',
      'Automated CI/CD pipelines',
    ],
    icon: 'code',
  },
  {
    id: 'saas-integration',
    title: 'SaaS Integration',
    tagline: 'Connect what you already use',
    blurb:
      'Unify your stack. We integrate CRMs, ERPs, payment, analytics, and messaging into a single source of truth.',
    details: [
      'REST & GraphQL orchestration',
      'Event-driven data sync',
      'Identity & SSO (SAML/OAuth)',
      'Vendor API hardening',
    ],
    icon: 'plug',
  },
  {
    id: 'it-consulting',
    title: 'IT Consulting',
    tagline: 'Strategy before code',
    blurb:
      'Architecture reviews, cloud migration roadmaps, and team enablement to de-risk every stage of growth.',
    details: [
      'Cloud & cost optimization',
      'Security & compliance audits',
      'Tech stack rationalization',
      'Fractional CTO advisory',
    ],
    icon: 'compass',
  },
];
